import React, { useEffect } from "react";
import { Routes, Route } from "react-router-dom";
import { useAppContext } from "../hooks/context/AppContext";
import Comments from "../pages/Comments";
import Home from "../pages/Home";
import NotFound from "../pages/NotFound";
import SignOffPage from "../pages/SignOffPage";
import { useLoader } from "../components/common/LoaderContext";
import AdminHome from "../pages/AdminHome";
import PageLayout from "../components/layout/PageLayout";
import { getHeaderText } from "../helpers/helper";

const AppRoutes: React.FC = () => {
  const { userData, userInitialized } = useAppContext();
  const roleAvailable = userInitialized && !!userData.Role;
  const { setLoading } = useLoader();
  const canAccessComments =
    userData.Role === "PREPARER" || userData.Role === "VIEW";
  const canAccessSignOff = userData.Role === "OCUSER";
  const isAdmin = userData.Role === "ADMIN";

  // Set loading state based on role availability
  useEffect(() => {
    if (!roleAvailable) {
      setLoading(true);
    } else {
      setLoading(false);
    }
  }, [roleAvailable, setLoading]);

  return (
    <Routes>
      <Route
        path="/"
        element={
          <PageLayout
            headerText={getHeaderText(isAdmin ? "AdminHome" : "Home")}
            roleAvailable={roleAvailable}
            landingPage
          >
            {isAdmin ? (
              <AdminHome
                roleAvailable={roleAvailable}
                userRole={userData.Role}
              />
            ) : (
              <Home roleAvailable={roleAvailable} userRole={userData.Role} />
            )}
          </PageLayout>
        }
      />
      {canAccessComments && (
        <Route
          path="/add-comments"
          element={
            <PageLayout
              headerText={getHeaderText("Comments")}
              roleAvailable={roleAvailable}
            >
              <Comments />
            </PageLayout>
          }
        />
      )}
      {canAccessSignOff && (
        <Route
          path="/sign-off-page"
          element={
            <PageLayout
              headerText={getHeaderText("SignOffPage")}
              roleAvailable={roleAvailable}
            >
              <SignOffPage />
            </PageLayout>
          }
        />
      )}
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

export default AppRoutes;
